<button [disabled]="!control.value"
        color="accent"
        tabindex="-1"
        matSuffix
        type="button"
        mat-icon-button
        (click)="clearFormControl()">
  <mat-icon>clear</mat-icon>
</button>